export enum PLAY_GALLERY {
    /**
     * @value All videos
     */
    ALL_VIDEOS = 'PLAY.ALL_VIDEOS',
    /**
     * @value Manage videos
     * @description Call to action button allowing authorized users to access the video library
     */
    MANAGE_VIDEOS = 'PLAY.MANAGE_VIDEOS',
    /**
     * @value Most popular
     * @description Used, for example, in a dropdown to sort videos by their number of popular
     */
    MOST_POPULAR = 'PLAY.MOST_POPULAR',
    /**
     * @value Most viewed
     * @description Used, for example, in a dropdown to sort videos by their number of views
     */
    MOST_VIEWED = 'PLAY.MOST_VIEWED',
    /**
     * @value You don‘t have any videos
     * @description The library has no video to display
     */
    NO_AVAILABLE_VIDEOS = 'PLAY.NO_AVAILABLE_VIDEOS',
    /**
     * @value There are no podcasts
     * @description Text used to tell our users that their video library does not contain any podcasts
     */
    NO_PODCAST = 'PLAY.NO_PODCAST',
    /**
     * @value No videos found
     * @description Label displayed when no videos were found in the video library / gallery
     */
    NO_VIDEOS_FOUND = 'PLAY.NO_VIDEOS_FOUND',
    /**
     * @value Search videos
     * @description Generic search videos label (used in text field as placeholder, could be use as a button label etc…)
     */
    SEARCH_VIDEOS = 'PLAY.SEARCH_VIDEOS',
    /**
     * @value Starred
     */
    STARRED = 'FRONT.WIDGET_FILE_LIST.SETTINGS.FOLDER.DRIVE.STARRED',
    /**
     * @value Upload video
     * @description Call to Action to select a video to import
     */
    UPLOAD_DIALOG_CTA = 'PLAY.UPLOAD_DIALOG_CTA',
    /**
     * @value From computer
     * @description List item from upload video dropdown
     */
    UPLOAD_FROM_COMPUTER = 'PLAY.UPLOAD_FROM_COMPUTER',
    /**
     * @value From Drive
     * @description List item from upload video dropdown
     */
    UPLOAD_FROM_DRIVE = 'PLAY.UPLOAD_FROM_DRIVE',
    /**
     * @value Video gallery
     * @description Title of the video gallery
     */
    VIDEO_GALLERY_TITLE = 'PLAY.VIDEO_GALLERY_TITLE',
    /**
     * @value Video podcasts
     * @description Text used has a title to indicate user can see the podcasts
     */
    VIDEO_PODCASTS = 'PLAY.PODCASTS',
    /**
     * @value Watch video
     */
    WATCH_VIDEO = 'PLAY.WATCH_VIDEO',
}
